import { Injectable } from '@nestjs/common';
import { Hatcheries } from '../hatcheries.entity';
import { HatcheriesDTO } from './hatcheries.dto';


@Injectable()
export class HatcheriesAdapter {
  
  public convertDtoToEntity(hatcheriesDTO: HatcheriesDTO,  isUpdate: boolean = false ): Hatcheries {
    const hatcheries = new Hatcheries();
    hatcheries.hatcheriesId=hatcheriesDTO.hatcheriesId;
    hatcheries.hatcheriesName=hatcheriesDTO.hatcheriesName;
    // company.isActive = statesDto.isActive == undefined ? true : statesDto.isActive;
    hatcheries.isActive=hatcheriesDTO.isActive==undefined?true:hatcheriesDTO.isActive;
    if (isUpdate) {
        hatcheries.updatedUser = hatcheriesDTO.updatedUser;
    } else {
        hatcheries.isActive = true;
        hatcheries.createdUser = hatcheriesDTO.createdUser;
    }
   return hatcheries;
  }
  public convertEntityToDto(hatcheriesObject: Hatcheries): HatcheriesDTO {
    const hatcheriesDto= new HatcheriesDTO;
    hatcheriesDto.hatcheriesId=hatcheriesObject.hatcheriesId;
    hatcheriesDto.hatcheriesName=hatcheriesObject.hatcheriesName;
    hatcheriesDto.isActive = hatcheriesObject.isActive;
    hatcheriesDto.createdAt = hatcheriesObject.createdAt;
    hatcheriesDto.updatedAt = hatcheriesObject.updatedAt;
    hatcheriesDto.createdUser = hatcheriesObject.createdUser;
    hatcheriesDto.updatedUser = hatcheriesObject.updatedUser;
    hatcheriesDto.versionFlag = hatcheriesObject.versionFlag;
    return hatcheriesDto;
  }
}
